// 接口响应
export interface ApiResponse<T> {
    code: number;
    message: string;
    data: T;
}

/** 入驻类型 */
export enum MerchantTypeEnum {
    /** 个人商家 */
    PERSONAL = 3,
    /** 企业商家 */
    ENTERPRISE = 4
}

/** 商家类型 */
export enum BusinessTypeEnum {
    /** 个人商家 */
    INDIVIDUAL_BUSINESS = 1,
    /** 个体户商家 */
    INDIVIDUAL_BUSINESSES = 2,
    /** 企业商家 */
    ENTERPRISE = 3
}

/** 证件类型 */
export enum IdCardTypeEnum {
    /** 中国大陆身份证 */
    ID_CARD = 0,
    /** 护照(境外签发) */
    OVERSEAS_PASSPORT = 1,
    /** 港澳居民来往内地通行证 */
    HKG = 2,
    /** 台湾居民来往大陆通行证 */
    PERMIT_FOR_TAIWAN = 3,
    /** 护照(中国签发) */
    CHINESE_PASSPORT = 4,
    /** 外国人永久居留证 */
    PRC = 5,
    /** 其他国家或地区身份证 */
    OTHER_ID_CARD = 6,
    /** 未知类型 */
    NO_CARE_TYPE = -1
}

/** 历史账户状态 */
export enum HistoryAccountStatusEnum {
    /** 无记录 */
    NO_RECORD = 1,
    /** 清算中 */
    WAIT_SETTLE = 2,
    /** 待提现 */
    WAIT_WITHDRAW = 3,
    /** 已结清 */
    SETTLED = 4
}

/** 客户端来源 */
export enum ClientFromEnum {
    /** 票务 */
    TICKET = 'ticket',
    /** 工坊 */
    UP = 'up'
}
